<template>
  <form class="form">
    <h2>Основные данные</h2>

    <div class="join join--lg join--mobile-col">
      <fieldset disabled>
        <div class="form__group">
          <t-text :model-value="store.application.surname || 'Не указано'" label="Фамилия"/>
          <t-text :model-value="store.application.name || 'Не указано'" label="Имя"/>
          <t-text :model-value="store.application.patronymic || 'Не указано'" label="Отчество"/>
        </div>

        <div class="form__group">
          <t-text :model-value="store.application.gender || 'Не указано'" label="Пол"/>
          <t-text :model-value="store.application.birthdate || 'Не указано'" label="Дата рождения"/>
          <div class="form__spacer"></div>
        </div>
      </fieldset>
    </div>

    <hr>

    <h2>Контактная информация</h2>
    <fieldset disabled>
      <div class="form__group">
        <t-text :model-value="store.application.phone || 'Не указано'" label="Телефон"/>
        <t-text :model-value="store.application.email || 'Не указано'" label="E-mail"/>
      </div>
    </fieldset>

    <hr>

    <div style="display: contents;">
      <h2>Место рождения</h2>
      <fieldset class="form form--fieldset" disabled>
        <t-text-growing
          :model-value="store.application.birth_place?.address_free_form || 'Не указано'"
          label="Адрес места рождения (Страна, область, город)"
        />
      </fieldset>

      <hr>

      <h2>Место жительства</h2>
      <fieldset class="form form--fieldset" disabled>
        <t-text-growing
          :model-value="store.application.registration?.address_free_form || 'Не указано'"
          label="Адрес места жительства (Страна, область, город, улица, дом, квартира)"
        />
      </fieldset>
    </div>

    <hr>

    <template v-if="store.application.need_hostel">
      <h2>Общежитие</h2>
      <fieldset disabled>
        <t-text
          :model-value="store.application.need_hostel ? 'Я нуждаюсь в общежитии' : 'Я не нуждаюсь в общежитии'"
          label="Необходимость в общежитии"
        />
      </fieldset>
    </template>
  </form>
</template>

<script setup>
import { TText, TTextGrowing, TCheckbox } from '@shared/ui'
import { useApplicationStore } from '@widgets/application-profile'

const store = useApplicationStore()
</script>
